// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1tGXu","calendarButtons":"ClockData_calendarButtons__3xgZ3"};